export default __webpack_public_path__ + "images/assets/dfdcb7986fd6daa8eecdfe4354b2fa83.svg";